import React from 'react';
import UserRow from './UserRow';
import GoogleAnalytics from '../../analyticsComponents/GoogleAnalytics.js';

const UserTable = ({ users, roles, modifiedUsers, onRoleChange, setModifiedUsers }) => {
  return (
    <>
      <GoogleAnalytics page="RoleAssignPage" eventType="roleAssign_page" />

      {users.length ? (
        <div className="mt-4">
          {/* Desktop/tablet table */}
          <div className="hidden md:block rounded-xl border border-gray-100 overflow-hidden shadow-card">
            <table className="w-full table-fixed text-sm text-left">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-100">
                  <th className="px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Email</th>
                  <th className="px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Full Name</th>
                  <th className="px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Institution</th>
                  <th className="px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Age</th>
                  <th className="px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Current Role</th>
                  <th className="px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Requested Role</th>
                  <th className="px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {users.map((user) => (
                  <UserRow
                    key={user.id}
                    user={user}
                    roles={roles}
                    modifiedUsers={modifiedUsers}
                    onRoleChange={onRoleChange}
                    setModifiedUsers={setModifiedUsers}
                    variant="row"
                  />
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile cards */}
          <div className="md:hidden space-y-2">
            {users.map((user) => (
              <UserRow
                key={user.id}
                user={user}
                roles={roles}
                modifiedUsers={modifiedUsers}
                onRoleChange={onRoleChange}
                setModifiedUsers={setModifiedUsers}
                variant="card"
              />
            ))}
          </div>
        </div>
      ) : (
        <p className="text-center mt-4 text-gray-500">No users found.</p>
      )}
    </>
  );
};

export default UserTable;
